import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The brand setup gate (docs/plans/2026-11-03-feat-pulse-ai-brand-setup-plan.md), spread into
 * FEATURE_GATE_SEEDS in feature-gate-registry.ts at its place in the admin page order. The row is created
 * by the pulse_ai_brand_setup_feature_gate migration.
 */
export const BRAND_SETUP_FEATURE_GATE_SEEDS = {
  pulse_ai_brand_setup: {
    label: 'Brand setup',
    shortLabel: 'Brand setup',
    description:
      'The Brand Kit page shows a live summary, one place to drop in a brand, and Brand, Email and Graphics tabs. Off, the page stays one long form.',
    group: 'campaigns_creative',
  },
} satisfies Record<string, FeatureGateSeed>;
